import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/login';
import { actions as actionsSolicitudes } from '../../../redux/modules/Compras/compras';
import { actions as actionsEB } from '../../../redux/modules/Bodega/estadobodega';
import { actions as actionsFcm } from '../../../redux/modules/fcm';
import Navbar from './Navbar';


const ms2p = (state) => {
  return {
    ...state.login,
    firebaseApp: state.fcm.firebaseApp
  };
};

const md2p = { ...actions, ...actionsSolicitudes, ...actionsEB, ...actionsFcm };

export default connect(ms2p, md2p)(Navbar);
